export class CancelledByUserError extends Error {
    constructor() {
        super('Cancelled by user');
    }
}
